// extracted by mini-css-extract-plugin
export default {"form":"CreatePetition_form__OHQd5","upload":"CreatePetition_upload__8pw6y","error":"CreatePetition_error__2ZPsd"};